import * as React from 'react';
import { SVGProps } from 'react';

const SvgEmailOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="m4.5 9.828-1.218-.72c-.123-.074-.281.018-.281.163v7.518c0 .781.632 1.414 1.414 1.414h15.17c.782 0 1.415-.633 1.415-1.414V9.27a.188.188 0 0 0-.281-.162l-1.219.719v6.875H4.5L4.5 9.828Z"
      fill="currentColor"
    />
    <path
      d="m12.366 12.508 8.532-5.037a.19.19 0 0 0 .092-.176A1.418 1.418 0 0 0 19.58 6H4.41C3.668 6 3.062 6.57 3 7.295c-.004.07.03.136.092.176l8.532 5.037a.746.746 0 0 0 .742 0Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgEmailOutlined;
